import React from 'react';
import './CollegeApplicationCTA.css';

const CollegeApplicationCTA = () => {
  return (
    <section className="section college-cta-section">
      <div className="container">
        <div className="college-cta-content">
          <div className="college-cta-text">
            <span className="college-cta-badge">New Feature</span>
            <h2 className="college-cta-title">
              Apply to Top Colleges Directly Through 12thPlus
            </h2>
            <p className="college-cta-description">
              Skip the hassle of multiple application portals. Browse colleges, submit applications,
              track your admission status, and get your offer letter — all in one place.
            </p>
            <div className="college-cta-features">
              <div className="college-cta-feature">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <span>Browse partner colleges across India</span>
              </div>
              <div className="college-cta-feature">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <span>One-click application with auto-filled details</span>
              </div>
              <div className="college-cta-feature">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <span>Real-time application tracking & updates</span>
              </div>
            </div>
            <div className="college-cta-buttons">
              <a
                href="https://12thplus.com/app/login?redirect=/college-applications"
                className="btn-apply"
              >
                Explore & Apply
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </a>
              <a
                href="https://12thplus.com/app/get-started"
                className="btn-learn"
              >
                Get Started Free
              </a>
            </div>
          </div>

          <div className="college-cta-visual">
            <div className="college-cta-card">
              <div className="college-cta-card-icon teal">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                  <path d="M6 12v5c3 3 9 3 12 0v-5" />
                </svg>
              </div>
              <div>
                <div className="college-cta-card-title">Partner Colleges</div>
                <div className="college-cta-card-desc">Browse from our growing network of verified partner institutions</div>
              </div>
            </div>
            <div className="college-cta-card">
              <div className="college-cta-card-icon blue">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                </svg>
              </div>
              <div>
                <div className="college-cta-card-title">Simple Application</div>
                <div className="college-cta-card-desc">Fill once, apply to multiple colleges with ease</div>
              </div>
            </div>
            <div className="college-cta-card">
              <div className="college-cta-card-icon orange">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              <div>
                <div className="college-cta-card-title">Track & Get Admitted</div>
                <div className="college-cta-card-desc">Monitor status, receive offer letters, confirm admission</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CollegeApplicationCTA;
